import axios from "axios";
import { Location_Service_URL } from "../Url";

export const locationListActions = {
  LOCATION_LIST: "LOCATION_LIST",
  LOCATION_LIST_SUCCESS: "LOCATION_LIST_SUCCESS",
  CITY_LIST: "CITY_LIST",
  CITY_LIST_ERROR: "CITY_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getLocation(props) {
  const { access_token, sortField, sortOrder, url, locationType } = props;
  let listing_Dto = {
    addtionalSearch: [],
    columnNames: [],
    defaultSort: {
      sortField: `${sortField}`,
      sortOrder: `${sortOrder}`,
    },
    isRegistered: true,
    length: 0,
    requestType: 0,
    search: [],
    sequenceColumnDTOs: [
      {
        columnID: 0,
        sequenceColumn: 0,
      },
    ],
    sort: [],
    start: 0,
    status: true,

    statusCode: 0,
  };
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Location_Service_URL}/getAll/${url}`,
      // data: listing_Dto
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getCityListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getLocationListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getLocationListError(err));
          return err.response;
        }
      });
}

export function getLocationListError(error) {
  return {
    type: locationListActions.CITY_LIST_ERROR,
    payload: error,
  };
}
export function getCityListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: locationListActions.CITY_LIST,
      payload: props,
    });
  };
}
